import React from "react";
import { cn } from "@gettactic/helpers";

export interface WizardReviewItemProps {
  label: string;
  value: React.ReactNode;
  className?: string;
  emptyText?: string;
}

export const WizardReviewItem: React.FC<WizardReviewItemProps> = ({
  label,
  value,
  className,
  emptyText = "—"
}) => (
  <div className={cn("flex justify-between text-sm", className)}>
    <span className="text-neutral-500">{label}</span>
    <span className="font-medium text-neutral-900">{value || emptyText}</span>
  </div>
);
